import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthActions, useAuthState, AUTH_PHASE } from "@/contexts/AuthContext";
import { isAuthPath } from "@/lib/layoutRouting";

function isAtRedirectTarget(pathname, target) {
    if (pathname === target) return true;
    if (target.startsWith("/admin") && pathname.startsWith("/admin") && pathname !== "/admin/login") {
        return true;
    }
    return false;
}

/**
 * Handles post-login/signup routing BEFORE authenticated layouts mount.
 * Inactive on auth-only routes to avoid navigation churn during login failures.
 */
export function AuthRedirectEffect() {
    const { authPhase, pendingRedirect } = useAuthState();
    const { finalizeAuthTransition } = useAuthActions();
    const navigate = useNavigate();
    const location = useLocation();
    const committingRef = useRef(false);

    useEffect(() => {
        if (isAuthPath(location.pathname) && authPhase !== AUTH_PHASE.REDIRECTING) {
            committingRef.current = false;
            return;
        }

        if (authPhase !== AUTH_PHASE.REDIRECTING || !pendingRedirect) {
            committingRef.current = false;
            return;
        }

        if (!isAtRedirectTarget(location.pathname, pendingRedirect)) {
            navigate(pendingRedirect, { replace: true });
            return;
        }

        if (!committingRef.current) {
            committingRef.current = true;
            finalizeAuthTransition();
        }
    }, [authPhase, pendingRedirect, location.pathname, navigate, finalizeAuthTransition]);

    return null;
}
